import React from "react";
import ContentLoader from "react-content-loader";

const PedidosSkeleton = () => {
  // Número de filas "falsas" de skeleton
  const rows = 3;
  // Altura de cada fila
  const rowHeight = 60;

  return (
    <>
      {Array.from({ length: rows }).map((_, index) => (
        <ContentLoader
          key={index}
          speed={2}
          width="100%"
          height={rowHeight}
          backgroundColor="#f3f3f3"
          foregroundColor="#ecebeb"
          style={{ width: "100%", maxWidth: "1300px" }}
        >
          {/* DESCRIPCIÓN (rect) */}
          <rect x="2%" y="15" rx="4" ry="4" width="34%" height="20" />

          {/* USUARIOS (2 círculos) */}
          <circle cx="45%" cy="25" r="10" />

          {/* TIEMPO RESTANTE (rect corto) */}
          <rect x="52%" y="15" rx="4" ry="4" width="13%" height="20" />

          {/* COMENTARIOS (círculo simulando ícono chat) */}
          <circle cx="68%" cy="25" r="10" />

          {/* ESTADO (rect “pill”) */}
          <rect x="77%" y="15" rx="8" ry="8" width="10%" height="20" />
        </ContentLoader>
      ))}
    </>
  );
};

export default PedidosSkeleton;
